import {
  WmProgressIndicator,
  WmProgressMonitor,
  WmProgressSlice
} from "@watermarkinsights/ripple-react";
import {
  groupLegend,
  notRespondedText,
  optedOut,
  respondedText,
  tooltipNotRespondedText,
  tooltipRespondedText
} from "./ResponseRateSection";
import { ResponseRateByCourseSection } from "../ResponseRateOverview";
import translate from "@/i18n/translate";
import useSmallScreenView from "@/features/common/useSmallScreenView";

interface ResponseRateFlyoutChartsProps {
  responseRate: ResponseRateByCourseSection;
  isLastRow: boolean;
  index: number;
  courseSectionLength: number;
}

export function ResponseRateFlyoutCharts({
  responseRate,
  index,
  courseSectionLength
}: ResponseRateFlyoutChartsProps) {
  let isSmallScreen = useSmallScreenView(1024);
  let lastRowLength = isSmallScreen
    ? courseSectionLength % 2 || 2
    : courseSectionLength % 3 || 3;

  const isLastRow = index >= courseSectionLength - lastRowLength;
  return (
    <div
      className={
        isLastRow
          ? "response-rate-chart-container last-row"
          : "response-rate-chart-container"
      }
    >
      <div className="course-section">{responseRate.courseSection}</div>
      <div className="project-name">{responseRate.projectTitle}</div>
      <div className="course-section-chart">
        <WmProgressMonitor
          id="ces-response-rate"
          groupLegend={groupLegend()}
          barLabelsWidth="0"
        >
          <WmProgressIndicator label={" "}>
            <WmProgressSlice
              amount={responseRate.respondedPercentage.toString()}
              popoverText={tooltipRespondedText(responseRate.optedOut)}
              legend={respondedText()}
              popoverTitle={`${responseRate.responded}/${responseRate.total}`}
              title={respondedText()}
            />
            <WmProgressSlice
              amount={responseRate.notRespondedPercentage.toString()}
              popoverText={tooltipNotRespondedText()}
              legend={notRespondedText()}
              popoverTitle={`${responseRate.notResponded}/${responseRate.total}`}
              title={notRespondedText()}
            />
          </WmProgressIndicator>
        </WmProgressMonitor>
        <div className="opted-out">{optedOut(responseRate.optedOut)}</div>
      </div>
    </div>
  );
}
